/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechPowerPlugDiagIcon16Light } from './TechPowerPlugDiagIcon16Light';
import { TechPowerPlugDiagIcon16Regular } from './TechPowerPlugDiagIcon16Regular';
import { TechPowerPlugDiagIcon16Solid } from './TechPowerPlugDiagIcon16Solid';
import { TechPowerPlugDiagIcon20Light } from './TechPowerPlugDiagIcon20Light';
import { TechPowerPlugDiagIcon20Regular } from './TechPowerPlugDiagIcon20Regular';
import { TechPowerPlugDiagIcon20Solid } from './TechPowerPlugDiagIcon20Solid';
import { TechPowerPlugDiagIcon24Regular } from './TechPowerPlugDiagIcon24Regular';
import { TechPowerPlugDiagIcon24Solid } from './TechPowerPlugDiagIcon24Solid';
import { TechPowerPlugDiagIcon32Regular } from './TechPowerPlugDiagIcon32Regular';
import { TechPowerPlugDiagIcon64Regular } from './TechPowerPlugDiagIcon64Regular';
var sizes = {
    16: {
        light: TechPowerPlugDiagIcon16Light,
        regular: TechPowerPlugDiagIcon16Regular,
        solid: TechPowerPlugDiagIcon16Solid,
    },
    20: {
        light: TechPowerPlugDiagIcon20Light,
        regular: TechPowerPlugDiagIcon20Regular,
        solid: TechPowerPlugDiagIcon20Solid,
    },
    24: {
        regular: TechPowerPlugDiagIcon24Regular,
        solid: TechPowerPlugDiagIcon24Solid,
    },
    32: {
        regular: TechPowerPlugDiagIcon32Regular,
    },
    64: {
        regular: TechPowerPlugDiagIcon64Regular,
    },
};
export var TechPowerPlugDiagIcon = forwardRef('TechPowerPlugDiagIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
